import {Component} from '@angular/core';

@Component({
    selector: 'db-route-wrapper',
    templateUrl: './route-wrapper.component.html',
    styleUrls: ['./route-wrapper.component.scss'],
    standalone: false
})
export class RouteWrapperComponent {

  constructor() {}

}
